import React from 'react';
import {useController} from 'react-hook-form';

import {Stack} from '../primitives';
import {TSpacingSize} from '../types';
import * as S from './style';

type TProps = {
  className?: string;
  hasError?: boolean;
  readOnly?: boolean;
  children: React.ReactNode;
  hint?: React.ReactNode | string;
  label?: React.ReactNode | string;
  htmlFor?: string;
  size?: TSpacingSize;
  style?: TAnyObject;
  justify?: string;
  width?: string;
  labelId?: string;
  innerRef?: React.Ref<any>;
};

const SectionWithBorder = React.memo<TProps>(
  ({
    className,
    hasError,
    label,
    hint,
    children,
    htmlFor,
    size,
    style,
    justify,
    width,
    readOnly,
    labelId,
    innerRef,
  }) => (
    <S.Border
      ref={innerRef}
      hasError={hasError}
      noFocus={readOnly}
      style={style}
      width={width}
      className={className}
    >
      <Stack size="2" isFullWidth>
        {label && (
          <S.Label htmlFor={htmlFor} id={labelId}>
            {label}
          </S.Label>
        )}
        {hint && <S.Hint>{hint}</S.Hint>}
        <Stack size={size ?? '0'} justify={justify} align="flex-start" isWrap isFullWidth>
          {children}
        </Stack>
      </Stack>
    </S.Border>
  ),
);

const SectionWithBorderField = React.memo<TProps & {name: string}>(
  ({name, hasError, children, ...props}) => {
    const {
      fieldState: {error: fieldError},
    } = useController({name});

    return (
      <SectionWithBorder hasError={hasError ?? !!fieldError} {...props}>
        {children}
      </SectionWithBorder>
    );
  },
);

export type {TProps};
export {SectionWithBorder, SectionWithBorderField};
